const filterAgencyStartOptions = (options, liveStart, liveEnd) => {
  if (!options || !liveStart || !liveEnd) return [];

  return options.filter((option) => {
    const optionValue = option?.value;
    return !(optionValue >= liveStart && optionValue < liveEnd);
  });
};

export default filterAgencyStartOptions;
